<!-- 仓位页面的商品入仓弹窗 -->
<template>
    <div v-loading="saveLoading">
        <div class="positionEdit-ctn">
            <div class="div-table-row table-title">
                <div class="div-table-cell" style="width: 25%">配件编码</div>
                <div class="div-table-cell" style="width: 25%">配件名称</div>
                <div class="div-table-cell" style="width: 25%">数量</div>
                <div class="div-table-cell" style="width: 25%">单位</div>
            </div>
            <div class="table-main">
                <div :key="index" class="div-table-row" v-for="(item, index) in dataList">
                    <div class="div-table-cell" style="width: 25%">
                        <el-select
                            default-first-option
                            size="small"
                            v-model="item.APCode"
                            value-key="APCode"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="汽配编码"
                            @change="codeChange($event, item)"
                            @visible-change="codeVisibleChange($event)"
                            :remote-method="searchCode"
                            v-select-scroll-more="searchCodeLoad"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in codeList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.APCode"
                                :value="optionItem.APCode"
                            >
                                <div class="option-content">
                                    <div style="width: 200px">{{ optionItem.APCode }}</div>
                                    <div>{{ optionItem.GoodName }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="codeForm.loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="div-table-cell" style="width: 25%">
                        <el-select
                            size="small"
                            v-model="item.GoodName"
                            filterable
                            clearable
                            remote
                            reserve-keyword
                            placeholder="配件名称"
                            @change="nameChange($event, item)"
                            @visible-change="nameVisibleChange($event)"
                            :remote-method="searchName"
                            v-select-scroll-more="searchNameLoad"
                            popper-class="el-select-style-gray"
                        >
                            <el-option
                                v-for="optionItem in nameList"
                                :key="optionItem.EntpTempGoodsId"
                                :data-msg="optionItem"
                                :label="optionItem.GoodName"
                                :value="optionItem.GoodName"
                            >
                                <div class="option-content">
                                    <div style="width: 200px">{{ optionItem.GoodName }}</div>
                                    <div>{{ optionItem.APCode }}</div>
                                </div>
                            </el-option>
                            <el-option v-if="nameForm.loading" disabled value="" style="text-align: center">
                                加载中
                                <i class="el-icon-loading"></i>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="div-table-cell" style="width: 25%">
                        <el-input size="small" type="number" v-model="item.Count" :max="item.UnStorageCount" min="0"></el-input>
                    </div>
                    <div class="div-table-cell" style="width: 25%">
                        <span>{{ item.Unit }}</span>
                    </div>
                    <el-button size="mini" icon="el-icon-minus" @click="delItem(index)" class="del-btn"></el-button>
                </div>
                <el-button size="mini" icon="el-icon-plus" class="add-btn" @click="addItem"></el-button>
            </div>
        </div>
        <div class="dialog-footer">
            <el-button class="btn-primary" size="small" @click="submitData">入库</el-button>
            <el-button @click="cancel()" size="small">取 消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['ShelfSpaceId', 'WarehouseId'],
    components: {},
    data() {
        return {
            saveLoading: false,
            codeLoading: false,
            nameLoading: false,
            canRequest: true,
            codeList: [],
            nameList: [],
            dataList: [],
            formData: {
                WarehouseId: this.WarehouseId,
                ShelfSpaceId: this.ShelfSpaceId,
                DetailList: []
            },
            codeForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: '',
                loading: false
            },
            nameForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: '',
                loading: false
            }
        };
    },
    mounted() {
        this.addItem();
    },
    methods: {
        //select下拉时触发
        codeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.codeList.length <= 0) that.searchCode('');
            }
        },
        //select下拉时触发
        nameVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.nameList.length <= 0) that.searchName('');
            }
        },
        searchCodeLoad() {
            if (!this.codeForm.loading && !this.codeForm.stopLoad) {
                this.codeForm.Page += 1;
                this.searchCode();
            }
        },
        // 搜索汽配编码
        searchCode(key) {
            if (this.codeForm.loading) return;
            // if (this.codeForm.stopLoad) return;
            if (![undefined].includes(key)) {
                this.codeForm.Page = 1;
                this.codeForm.stopLoad = false;
                this.codeForm.key = key;
                this.codeList = [];
            }

            this.codeForm.loading = true;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpShelfSpaces/GetEntpUnStorageGoodsList',
                        data: {
                            APCode: this.codeForm.key,
                            Page: this.codeForm.Page,
                            Limit: this.codeForm.Limit
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.codeForm.loading = false;
                        if (!res.data) return;
                        this.codeForm.stopLoad = res.data.length < this.codeForm.Limit;
                        this.codeList = this.$util.uniqueArr(this.codeList, res.data);
                        resolve();
                    })
                    .catch(() => {
                        this.nameForm.loading = false;
                    });
            });
        },
        searchNameLoad() {
            if (!this.nameForm.loading && !this.nameForm.stopLoad) {
                this.nameForm.Page += 1;
                this.searchName();
            }
        },
        // 搜索名称
        searchName(key) {
            if (this.nameForm.loading) return;
            // if(this.nameForm.stopLoad) return;
            if (![undefined].includes(key)) {
                this.nameForm.Page = 1;
                this.nameForm.stopLoad = false;
                this.nameForm.key = key;
                this.nameList = [];
            }
            this.nameForm.loading = true;
            return new Promise(resolve => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpShelfSpaces/GetEntpUnStorageGoodsList',
                        data: {
                            GoodName: this.nameForm.key,
                            Page: this.nameForm.Page,
                            Limit: this.nameForm.Limit
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.nameForm.loading = false;
                        if (!res.data) return;
                        this.nameForm.stopLoad = res.data.length < this.nameForm.Limit;
                        this.nameList = this.$util.uniqueArr(this.nameList, res.data);
                        resolve();
                    })
                    .catch(() => {
                        this.nameForm.loading = false;
                    });
            });
        },

        // 编码改变
        codeChange(value, goodsItem) {
            let that = this;
            if (value) {
                let goods = that.codeList.find(e => e.APCode == value);
                if (goods) {
                    goodsItem.EntpTempGoodsId = goods.EntpTempGoodsId;
                    //计算商品已填写的入仓数
                    let inputCount = 0;
                    for (let i = 0; i < that.dataList.length; i++) {
                        if (that.dataList[i].EntpTempGoodsId && goodsItem.EntpTempGoodsId == that.dataList[i].EntpTempGoodsId) inputCount += Number(that.dataList[i].Count);
                    }
                    goodsItem.APCode = goods.APCode;
                    goodsItem.GoodName = goods.GoodName;
                    goodsItem.Unit = goods.Unit;
                    goodsItem.UnStorageCount = goods.UnStorageCount;
                    let cal = Number(goodsItem.UnStorageCount - inputCount);
                    goodsItem.Count = cal >= 0 ? cal : 0;
                }
            } else {
                goodsItem.APCode = '';
                goodsItem.EntpTempGoodsId = '';
                goodsItem.GoodName = '';
                goodsItem.Unit = '';
                goodsItem.UnStorageCount = '';
                goodsItem.Count = '';
            }
        },
        // 名称改变
        nameChange(value, goodsItem) {
            let that = this;
            if (value) {
                let goods = that.nameList.find(e => e.GoodName == value);
                if (goods) {
                    goodsItem.EntpTempGoodsId = goods.EntpTempGoodsId;
                    //计算商品已填写的入仓数
                    let inputCount = 0;
                    for (let i = 0; i < that.dataList.length; i++) {
                        if (that.dataList[i].EntpTempGoodsId && goodsItem.EntpTempGoodsId == that.dataList[i].EntpTempGoodsId) inputCount += Number(that.dataList[i].Count);
                    }

                    goodsItem.APCode = goods.APCode;
                    goodsItem.GoodName = goods.GoodName;
                    goodsItem.Unit = goods.Unit;
                    goodsItem.UnStorageCount = goods.UnStorageCount;
                    let cal = Number(goodsItem.UnStorageCount - inputCount);
                    goodsItem.Count = cal >= 0 ? cal : 0;
                }
            } else {
                goodsItem.APCode = '';
                goodsItem.EntpTempGoodsId = '';
                goodsItem.GoodName = '';
                goodsItem.Unit = '';
                goodsItem.UnStorageCount = '';
                goodsItem.Count = '';
            }
        },
        // 删除某行
        delItem(index) {
            if (this.dataList.length != 1) {
                this.dataList.splice(index, 1);
            }
        },
        addItem() {
            let _dataList = this.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    this.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    this.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (Number(_dataList[i].Count) < 0) {
                    this.$util.warningMsg('请填写正确的数量');
                    return;
                }
                if (Number(_dataList[i].Count) > _dataList[i].UnStorageCount) {
                    this.$util.warningMsg(`超过可存放最大数量${_dataList[i].UnStorageCount}`);
                    return;
                }
            }
            this.dataList.push({
                APCode: '',
                GoodName: '',
                EntpTempGoodsId: '',
                Count: '',
                Unit: '',
                UnStorageCount: ''
            });
        },
        submitData() {
            let that = this;
            let _dataList = that.dataList;
            for (let i = 0; i < _dataList.length; i++) {
                if (!_dataList[i].APCode) {
                    that.$util.warningMsg('请填写配件编码');
                    return;
                }
                if (!_dataList[i].GoodName) {
                    that.$util.warningMsg('请填写配件名称');
                    return;
                }
                if (Number(_dataList[i].Count) <= 0) {
                    that.$util.warningMsg('请填写正确的数量');
                    return;
                }

                let inputCount = 0;
                for (let j = 0; j < _dataList.length; j++) {
                    if (_dataList[i].EntpTempGoodsId == _dataList[j].EntpTempGoodsId) inputCount += Number(_dataList[j].Count);
                }
                if (inputCount > _dataList[i].UnStorageCount) {
                    that.$util.warningMsg(`商品【${_dataList[i].GoodName}】超过可存放最大数量${_dataList[i].UnStorageCount}`);
                    return;
                }
            }
            that.saveLoading = true;
            that.formData.DetailList = that.dataList;
            this.$util
                .axiosPost({
                    url: '/api/EntpShelfSpaces/SaveEnterpriseGoodsLocationPart',
                    data: that.formData,
                    hideLoading: true
                })
                .then(res => {
                    that.saveLoading = false;
                    that.$util.successMsg(res.errmsg);
                    that.$emit('closeDialog', true);
                })
                .catch(() => {
                    that.canRequest = true;
                    that.saveLoading = false;
                });
        },
        cancel() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scoped>
.dialog-footer {
    text-align: right;
    margin-top: 20px;
}
.positionEdit-ctn {
    margin-right: 80px;
}
.table-title {
    .div-table-cell {
        height: 30px;
        line-height: 30px;
        text-align: center;
    }
}
.table-main {
    position: relative;
    .div-table-row {
        position: relative;
        overflow: visible;
    }
    .div-table-cell {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 5px;
        text-align: center;
    }
}
.del-btn {
    position: absolute;
    top: 7px;
    right: -50px;
}
.add-btn {
    position: absolute;
    top: 7px;
    right: -100px;
}
.option-content {
    display: flex;
    line-height: 30px;
}
</style>
